import { createGuid } from '@office-start/guid-generator';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { httpPost } from '@office-start/xhr-service';
import { createRequestConfig } from './createRequestConfig';
import { getRootUrl } from './getRootUrl';
/**
 * Internal contract for Recommended API for action_type
 */
export var FilesActionsType;
(function (FilesActionsType) {
    FilesActionsType[FilesActionsType["Unknown"] = 0] = "Unknown";
    /**
     * When something is added to To Do
     */
    FilesActionsType[FilesActionsType["AddToToDo"] = 1] = "AddToToDo";
    /**
     * When a piece of content is converted to PDF
     */
    FilesActionsType[FilesActionsType["ConvertToPdf"] = 2] = "ConvertToPdf";
    /**
     * PDF is created from a source piece of content
     */
    FilesActionsType[FilesActionsType["PdfCreated"] = 3] = "PdfCreated";
})(FilesActionsType || (FilesActionsType = {}));
export var addFilesActionsInternal = function (request, options, isUseFeedApi) {
    var aadClientId = options.aadClientId, correlationId = options.correlationId, filesActionsPath = options.filesActionsPath, getAccessToken = options.getAccessToken, inMockMode = options.inMockMode, jwtAuthEnabled = options.jwtAuthEnabled, objectId = options.objectId, officeApiRoot = options.officeApiRoot, rootPath = options.rootPath, substrateAppId = options.substrateAppId, substrateApi = options.substrateApi, tenantId = options.tenantId;
    var apiRoot = substrateApi;
    var mockParams;
    if (inMockMode) {
        apiRoot = officeApiRoot;
        mockParams = {
            mockParam: 'mockrecommendedfilesactions',
        };
    }
    var url = "".concat(getRootUrl({
        apiRoot: apiRoot,
        rootPath: rootPath,
    }), "/").concat(filesActionsPath);
    // translate from AddFilesRequest to IFilesActionsRequestBody
    var requestBody = {
        id: request.id,
        action_type: request.type,
        // $TODO: If there are many more types, will create a mapped type to look this up.
        source_file_id: request.type === FilesActionsType.PdfCreated
            ? request.sourceFileId
            : undefined,
    };
    return httpPost(isUseFeedApi
        ? KnownInstrumentationEvents.OfficeFeedAction
        : KnownInstrumentationEvents.RecommendedFilesActions, isUseFeedApi
        ? "OfficeFeedAction" /* KnownRequestInstrumentationEvents.OfficeFeedAction */
        : "Recommended_Files_Actions" /* KnownRequestInstrumentationEvents.RecommendedFilesActions */, url, JSON.stringify(requestBody), createRequestConfig({
        aadClientId: aadClientId,
        objectId: objectId,
        requestId: createGuid(),
        substrateAppId: substrateAppId,
        tenantId: tenantId,
    }), jwtAuthEnabled, getAccessToken, officeApiRoot, correlationId, 'Substrate', mockParams);
};
//# sourceMappingURL=addFilesActionsInternal.js.map